import { features } from "@/mocks/guaContent";

export default function Feature() {
  return (
    <section id="feature" className="relative bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold text-primary-600 tracking-wide">FEATURE · 深度专题</p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900">
            热点背后，总有一些值得细想的事
          </h2>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            八卦不止于表面。每周围绕一个议题做扎实的梳理与解读，把「吃瓜」吃出营养。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-8">
          {features.map((f, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <article
                key={f.title}
                className="grid grid-cols-1 lg:grid-cols-2 items-center gap-0 rounded-lg overflow-hidden bg-background-100 border border-background-200"
              >
                <div className={"relative aspect-[16/9] lg:aspect-auto lg:min-h-[300px] overflow-hidden " + (reverse ? "lg:order-2" : "")}>
                  <img
                    src={f.image}
                    alt={f.title}
                    className="w-full h-full object-cover transition duration-500 hover:scale-105"
                  />
                </div>
                <div className={"p-6 md:p-10 flex flex-col " + (reverse ? "lg:order-1" : "")}>
                  <span className="text-xs font-semibold uppercase tracking-wider text-secondary-700 bg-secondary-100 rounded-full px-3 py-1 inline-flex items-center gap-1.5 self-start">
                    <i className="ri-book-2-line"></i>{f.eyebrow}
                  </span>
                  <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-900 leading-snug">
                    {f.title}
                  </h3>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{f.excerpt}</p>
                  <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5"><i className="ri-time-line"></i>{f.readTime} 阅读</span>
                    <span className="flex items-center gap-1.5"><i className="ri-user-line"></i>{f.author}</span>
                    <span className="flex items-center gap-1.5"><i className="ri-calendar-line"></i>{f.date}</span>
                  </div>
                  <a
                    href="#plans"
                    className="mt-6 inline-flex items-center gap-1.5 self-start whitespace-nowrap rounded-md border border-primary-300 text-primary-700 text-sm font-medium px-5 py-2.5 hover:bg-primary-500 hover:text-white transition"
                  >
                    订阅后阅读全文 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}